<template>
  <div class="cuerpo-cupon">
    <button class="btn-inicio-cupon" @click="clickInicio()">
      <img :src="UrlFlecha" />
      INICIO
    </button>
    <div>
      <div class="contenedor-cupon" v-if="model">
        <!-- Válida -->
        <div class="cupon" v-if="model.esValido" id="cupon">
          <img :src="model.urlLogo" />
          <h3>COMPROBANTE DESCUENTO</h3>
          <div class="cliente-cupon">
            <h4>CLIENTE</h4>
            <p>{{ model.nombreCliente }}</p>
          </div>

          <div class="montos">
            <h4>PRECIO</h4>
            <p>{{ model.precio }}</p>
            <h4>DESCUENTO</h4>
            <p>{{ model.porcentajeDescuento }}</p>
            <p>{{ model.montoAhorrado }}</p>
            <h4>PRECIO FINAL</h4>
            <p>{{ model.precioFinal }}</p>
          </div>
        </div>
        <!-- Error -->
        <div v-else>
          {{ model.mensajeError }}
        </div>
      </div>
      <div v-else>Cargando...</div>
      <!-- Botones -->
      <div class="botonera-cupon">
        <button v-if="model && model.esValido" @click="clickImprimir()">
          <img :src="UrlImprimir" />
          <span v-if="!model.preparandoImpresion">IMPRIMIR CUPÓN</span>

          <!-- Preparando impresión -->
          <span v-else>Preparando...</span>
        </button>
        <button @click="clickVolver()">
          <img :src="UrlVolver" />
          VOLVER
        </button>
        <button @click="clickRegistroDescuentos()">
          <img :src="UrlLapiz" />
          REGISTRO DESCUENTOS
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { Printd } from "printd";

import { Util } from "../../util";
import { RouteNames } from "../../routes/comerciante.routes";

const LOGO_CORAZON_URL = "img/corazon-cupon.svg";
const ICO_FLECHA_IZQ_URL = "img/ico-flecha-izq.svg";
const ICO_IMPRIMIR_URL = "img/ico-impresora.svg";
const ICO_VOLVER_URL = "img/ico-volver.svg";
const ICO_LAPIZ = "img/ico-pencil.svg";

export default {
  props: {
    venta: Object,
  },
  data() {
    return {
      model: null,
    };
  },
  computed: {
    UrlFlecha() {
      return ICO_FLECHA_IZQ_URL;
    },
    UrlImprimir() {
      return ICO_IMPRIMIR_URL;
    },
    UrlLapiz() {
      return ICO_LAPIZ;
    },
    UrlVolver() {
      return ICO_VOLVER_URL;
    },
  },
  methods: {
    clickImprimir() {
      // Para no mandar a imprimir varias veces al mismo tiempo
      if (!this.model.preparandoImpresion) {
        this.model.preparandoImpresion = true;

        const d = new Printd();

        // TODO: en un futuro buscar una forma de no repetir acá y reusar lo que está en <styles>
        // Poner el estilo para imprimir
        const cssText = `

          .cuerpo-cupon {
	 padding: 30px 10%;
}
 .contenedor-cupon {
	 display: flex;
	 flex-direction: column;
	 align-items: center;
}
 .cupon {
	 border: 2px solid black;
	 width: 615px;
	 height: 536px;
	 display: flex;
	 flex-direction: column;
	 align-items: center;
}
 .cupon img {
	 margin-top: 22px;
	 margin-bottom: 31px;
}
 .cupon h3 {
	 font-weight: 700;
	 height: 45px;
	 font-size: 24px;
	 line-height: 28px;
	 border-top: 2px solid black;
	 border-bottom: 2px solid black;
	 width: 80%;
	 text-align: center;
	 padding-top: 1vw;
	 margin-bottom: 28px;
}
 .cupon h4 {
	 font-weight: 400;
	 font-size: 16px;
	 line-height: 18px;
	 text-align: center;
}
 .cupon p {
	 text-align: center;
	 font-weight: 700;
	 font-size: 18px;
	 line-height: 21px;
	 margin-bottom: 0px;
}
 .cupon .cliente-cupon {
	 margin-bottom: 35px;
}
 .cupon .montos {
	 display: grid;
	 grid-template-columns: 150px 100px 100px;
	 grid-template-rows: repeat(3, 20px);
	 row-gap: 30px;
}
 .cupon .montos h4 {
	 text-align: right;
}
 .cupon .montos p {
	 text-align: left;
	 margin-left: 50px;
	 text-decoration: underline black;
	 -webkit-text-decoration: underline black;
}
 .cupon .montos h4:nth-child(1) {
	 grid-column: 1 / 2;
      grid-row: 1 / 2;
}
 .cupon .montos p:nth-child(2) {
	 grid-column: 2 / 4;
      grid-row: 1 / 2;
}
 .cupon .montos h4:nth-child(3) {
	 grid-column: 1 / 2;
      grid-row: 2 / 3;
}
 .cupon .montos p:nth-child(4) {
	 grid-column: 2 / 3;
      grid-row: 2 / 3;
}
 .cupon .montos p:nth-child(5) {
	 grid-column: 3 / 4;
      grid-row: 2 / 3;
      margin-left: 0;
      text-align: center;
}
 .cupon .montos h4:nth-child(6) {
	 grid-column: 1 / 2;
      grid-row: 3 / 4;
}
 .cupon .montos p:nth-child(7) {
	 grid-column: 2 / 4;
      grid-row: 3 / 4;
}
 .botonera-cupon {
	 display: flex;
	 flex-direction: row;
	 justify-content: space-between;
}
 
 
      `;

        // TODO: en un futuro reutilizar los estilos de bootstrap locales
        const bootstrapStyles =
          "https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css";

        d.print(
          document.getElementById("cupon"),
          [cssText, bootstrapStyles],
          undefined,
          this.impresionPreparada
        );
      }
    },
    clickInicio() {
      this.$router.push("/comerciante");
    },
    clickRegistroDescuentos() {
      this.$router.push({ name: RouteNames.HistorialVentas });
    },
    clickVolver() {
      this.$router.push("/comerciante");
    },
    // Cuando la impresión está lista para hacerse, se cargaron los estilos, los scripts, etc
    impresionPreparada({ launchPrint }) {
      // Decirle a printD que abra el diálogo de impresión
      launchPrint();

      this.model.preparandoImpresion = false;
    },
  },
  mounted() {
    if (this.venta) {
      const montoAhorrado = this.venta.limiteDescuento;
      const precioFinal =
        this.venta.precio * (1 - this.venta.porcentajeDescuento / 100);

      this.model = {
        esValido: true,
        urlLogo: LOGO_CORAZON_URL,
        nombreCliente: this.venta.nombreCliente,
        precio: Util.formatMoney(this.venta.precio),
        porcentajeDescuento: this.venta.porcentajeDescuento + "%",
        montoAhorrado: Util.formatMoney(montoAhorrado),
        precioFinal: Util.formatMoney(precioFinal),
        preparandoImpresion: false,
      };
    } else {
      this.model = {
        esValido: false,
        mensajeError: "Ocurrió un error inesperado",
      };
    }
  },
};
</script>
<style lang="scss">
:root {
  --color-celeste-cupon: #01a6a2;
}

.cuerpo-cupon {
  padding: 30px 10%;
}

.btn-inicio-cupon {
  background: transparent;
  // justify-self: left;
  // display: flex;
  color: var(--color-celeste-cupon);
  font-size: 16px;
  line-height: 18px;
  margin-bottom: 12px;
  margin-right: 542px;
  img {
    width: 19px;
    bottom: 1px;
    position: relative;
  }
}

.contenedor-cupon {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cupon {
  border: 1px solid black;
  width: 615px;
  height: 536px;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-top: 22px;
    margin-bottom: 31px;
  }
  h3 {
    font-weight: 700;
    height: 45px;
    font-size: 24px;
    line-height: 28px;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    width: 80%;
    text-align: center;
    padding-top: 9px;
    margin-bottom: 28px;
  }
  h4 {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
  }
  p {
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    margin-bottom: 0px;
  }
  .cliente-cupon {
    margin-bottom: 35px;
  }

  .montos {
    display: grid;
    grid-template-columns: 150px 100px 100px;
    grid-template-rows: repeat(3, 20px);
    row-gap: 30px;
    h4 {
      text-align: right;
    }
    p {
      text-align: left;
      margin-left: 50px;
      text-decoration: underline black;
      -webkit-text-decoration: underline black;
    }
    h4:nth-child(1) {
      grid-column: 1 / 2;
      grid-row: 1 / 2;
    }
    p:nth-child(2) {
      grid-column: 2 / 4;
      grid-row: 1 / 2;
    }
    h4:nth-child(3) {
      grid-column: 1 / 2;
      grid-row: 2 / 3;
    }
    p:nth-child(4) {
      grid-column: 2 / 3;
      grid-row: 2 / 3;
    }
    p:nth-child(5) {
      grid-column: 3 / 4;
      grid-row: 2 / 3;
      margin-left: 0;
      text-align: center;
    }
    h4:nth-child(6) {
      grid-column: 1 / 2;
      grid-row: 3 / 4;
    }
    p:nth-child(7) {
      grid-column: 2 / 4;
      grid-row: 3 / 4;
    }
  }
}

.botonera-cupon {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin-top: 62px;
  gap: 20px;
  button {
    width: 274px;
    height: 48px;
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
    color: white;
    border-radius: 6px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
  button:nth-child(1) {
    background: #39a935;
    img {
      margin-right: 9px;
    }
  }
  button:nth-child(2) {
    background: #939a92;
  }
  button:nth-child(3) {
    background: var(--color-celeste-cupon);
  }
}

@media (max-width: 400px) and (min-width: 1px) {
  .cupon {
    height: calc(150px + 52vw);
    .montos {
      grid-template-columns: 30vw 20vw 20vw;
      p {
        margin-left: 8vw;
      }
      h4,
      p {
        font-size: 4vw;
      }
    }
  }
}

@media (max-width: 600px) and (min-width: 1px) {
  .cupon {
    h3 {
      line-height: 4vw;
    }
  }
  .botonera-cupon {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 600px) and (min-width: 400px) {
  .cupon {
    height: calc(70vw + 75px);
    h3 {
      line-height: 4vw;
    }
  }
}

@media (max-width: 800px) and (min-width: 601px) {
  .cupon {
    height: calc(67vw + 45px);
    h3 {
      line-height: 4vw;
    }
    .montos {
      h4,
      p {
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 800px) {
  .cuerpo-cupon {
    padding: 30px 5px;
  }
  .cupon {
    width: 95%;
    img {
      width: 30%;
    }
    h3 {
      font-size: 3.8vw;
      height: 7vw;
      padding-top: 1.5vw;
      margin-bottom: 4vw;
    }
    .cliente-cupon {
      margin-bottom: 5vw;
    }
    .montos {
      row-gap: 3vw;
    }
  }
  .btn-inicio-cupon {
    justify-self: left;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: auto;
    margin-left: 5px;
  }
}
</style>
